import React, {useEffect, useMemo} from 'react'
import PropTypes from 'prop-types'
import useOcapiSite from '../../hooks/useOcapiSite'
import {PayPalMessages, usePayPalScriptReducer} from '@paypal/react-paypal-js'
import {useLeapTheme} from '../../leap/theme'

const TEXT_COLOR_BY_THEME = {
    light: 'black',
    dark: 'white'
}

const BASE_STYLE = {
    layout: 'text',
    logo: {
        type: 'primary'
    },
    text: {
        size: 14
    }
}

const PaypalPayLater = ({amount, currency, placement}) => {
    const {enablePaypalLater, paypalLaterClientID} = useOcapiSite().customPreferences
    const [theme, themeRef] = useLeapTheme()
    const style = useMemo(
        () => ({
            ...BASE_STYLE,
            text: {...BASE_STYLE.text, color: TEXT_COLOR_BY_THEME[theme]}
        }),
        [theme]
    )

    const [{isInitial}, dispatch] = usePayPalScriptReducer()

    // load paypal on mount
    useEffect(() => {
        if (enablePaypalLater && paypalLaterClientID && isInitial) {
            dispatch({
                type: 'setLoadingStatus',
                value: 'pending'
            })
        }
    }, [dispatch, enablePaypalLater, paypalLaterClientID, isInitial])

    if (!enablePaypalLater || !paypalLaterClientID || !(amount > 0) || !currency) {
        return null
    }

    return (
        // The theme ref goes on a wrapper rather than on `PayPalMessages` itself for two
        // reasons: `PayPalMessages` is a plain function component, not a `forwardRef` one,
        // so it takes no ref from outside; and the theme has to be resolved before we can
        // build the `style` we hand it, so the probe has to sit outside it either way.
        <div ref={themeRef} style={{display: 'contents'}}>
            <PayPalMessages
                amount={amount}
                currency={currency}
                placement={placement}
                style={style}
                forceReRender={[amount, currency, theme]}
            />
        </div>
    )
}

PaypalPayLater.propTypes = {
    amount: PropTypes.number,
    currency: PropTypes.string,
    placement: PropTypes.oneOf(['home', 'category', 'product', 'cart', 'payment'])
}

export default PaypalPayLater
